import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/public.css';
import { getPublishedPosts } from '../services/blogService';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'10px 20px',borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, background:'var(--accent)', color:'var(--primary)' };
  const btnO = { ...btn, background:'transparent', color:'var(--primary)', border:'1.5px solid var(--border)' };
  const NAV_LINKS = [{ href:'/api', label:'API' },{ href:'/#precos', label:'Preços' },{ href:'/sobre', label:'Empresa' },{ href:'/ajuda', label:'Suporte' }];
  return (
    <nav style={{ position:'fixed',top:0,left:0,right:0,zIndex:1000,padding:scrolled?'12px 0':'16px 0',background:(scrolled||mobileMenu)?'rgba(255,255,255,0.95)':'transparent',backdropFilter:(scrolled||mobileMenu)?'blur(20px)':'none',borderBottom:(scrolled||mobileMenu)?'1px solid var(--border)':'none',transition:'all 0.4s' }}>
      <div className="container" style={{ display:'flex',alignItems:'center',justifyContent:'space-between' }}>
        <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
          <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
          SimulaBank
        </Link>
        <div className="desk-nav" style={{ display:'flex',alignItems:'center',gap:28 }}>
          {NAV_LINKS.map(({href,label}) => <Link key={href} to={href} style={{ textDecoration:'none',color:'var(--text-muted)',fontSize:'0.9rem',fontWeight:500 }}>{label}</Link>)}
        </div>
        <div className="desk-btns" style={{ display:'flex',gap:12,alignItems:'center' }}>
          <Link to="/login" style={btnO}>Entrar</Link>
          <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`} target="_blank" rel="noopener noreferrer" style={btnP}>Começar grátis</Link>
        </div>
        <button className="mob-toggle" onClick={() => setMobileMenu(!mobileMenu)} style={{ display:'none',flexDirection:'column',gap:4.5,background:'none',border:'none',cursor:'pointer',padding:8 }}>
          {[0,1,2].map(i => <span key={i} style={{ display:'block',width:22,height:2,borderRadius:1,background:'var(--primary)',transition:'all 0.3s',...(i===0&&mobileMenu?{transform:'rotate(45deg) translate(4.5px,4.5px)'}:{}),...(i===1&&mobileMenu?{opacity:0}:{}),...(i===2&&mobileMenu?{transform:'rotate(-45deg) translate(4.5px,-4.5px)'}:{}) }} />)}
        </button>
      </div>
      {mobileMenu && (
        <div className="mob-menu" style={{ display:'flex',flexDirection:'column',padding:'12px 24px 20px',background:'rgba(255,255,255,0.98)',borderTop:'1px solid var(--border)' }}>
          {NAV_LINKS.map(({href,label}) => <Link key={href} to={href} onClick={() => setMobileMenu(false)} style={{ textDecoration:'none',color:'var(--text)',fontSize:'0.95rem',fontWeight:500,padding:'12px 0',borderBottom:'1px solid var(--border)' }}>{label}</Link>)}
          <div style={{ display:'flex',gap:10,marginTop:16 }}>
            <Link to="/login" style={{ ...btnO,flex:1,textAlign:'center',justifyContent:'center' }}>Entrar</Link>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`}  style={{ ...btnP,flex:1,textAlign:'center',justifyContent:'center' }}>Começar grátis</Link>
          </div>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  const COLS = [
    { title:'Produto', links:[{l:'Funcionalidades',h:'/#features'},{l:'Preços',h:'/#precos'},{l:'API',h:'/api'},{l:'Changelog',h:'/changelog'}] },
    { title:'Empresa', links:[{l:'Sobre',h:'/sobre'},{l:'Blog',h:'/blog'},{l:'Contato',h:`https://wa.me/5561991826667?text=${encodeURIComponent('Quero conhecer o simulabank!')}`},{l:'Carreiras',h:'/carreiras'}] },
    { title:'Suporte', links:[{l:'Central de ajuda',h:'/ajuda'},{l:'Documentação',h:'/docs'},{l:'Status',h:'/status'},{l:'WhatsApp',h:'/whatsapp'}] },
  ];
  return (
    <footer style={{ padding:'60px 0 32px',borderTop:'1px solid var(--border)' }}>
      <div className="container">
        <div className="footer-grid" style={{ marginBottom:48 }}>
          <div>
            <Link to="/" style={{ display:'flex',alignItems:'center',gap:10,textDecoration:'none',fontWeight:700,fontSize:'1.3rem',color:'var(--primary)' }}>
              <div style={{ width:36,height:36,background:'var(--primary)',borderRadius:6,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--accent)',fontWeight:700,fontSize:'1.1rem' }}>S</div>
              SimulaBank
            </Link>
            <p style={{ color:'var(--text-muted)',fontSize:'0.88rem',marginTop:12,maxWidth:280,lineHeight:1.6 }}>A ferramenta definitiva para simulação e comparação de financiamento imobiliário entre múltiplos bancos.</p>
          </div>
          {COLS.map(col => (
            <div key={col.title}>
              <h4 style={{ fontSize:'0.8rem',fontWeight:600,textTransform:'uppercase',letterSpacing:'0.1em',color:'var(--text-muted)',marginBottom:16 }}>{col.title}</h4>
              {col.links.map(({l,h}) => <Link key={l} to={h} style={{ display:'block',color:'var(--text)',textDecoration:'none',fontSize:'0.9rem',padding:'4px 0' }}>{l}</Link>)}
            </div>
          ))}
        </div>
        <div className="footer-bottom" style={{ paddingTop:24,borderTop:'1px solid var(--border)',fontSize:'0.82rem',color:'var(--text-muted)' }}>
          <span>© 2026 SimulaBank. Todos os direitos reservados.</span>
          <div style={{ display:'flex',gap:24 }}>
            {['Termos de uso','Privacidade','LGPD'].map(l => <a key={l} href="#" style={{ color:'var(--text-muted)',textDecoration:'none' }}>{l}</a>)}
          </div>
        </div>
      </div>
    </footer>
  );
}

function useReveal() {
  const revealRefs = useRef([]);
  const [tick, setTick] = useState(0);
  const addReveal = el => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
      setTick(t => t + 1); // trigger re-observe
    }
  };
  const revealStyle = { opacity:0, transform:'translateY(24px)', transition:'all 0.7s cubic-bezier(0.16,1,0.3,1)' };
  useEffect(() => {
    const obs = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; } }), { threshold:0.08 });
    revealRefs.current.forEach(el => el && obs.observe(el));
    return () => obs.disconnect();
  }, [tick]);
  return { addReveal, revealStyle };
}

function PageHero({ label, title, subtitle, dark = false, children }) {
  return (
    <section style={{ padding:'160px 0 80px', position:'relative', overflow:'hidden', background: dark ? 'var(--primary)' : 'var(--surface)' }}>
      <div style={{ position:'absolute',top:-300,right:-200,width:700,height:700,background:`radial-gradient(circle, rgba(0,214,143,${dark?0.12:0.06}) 0%, transparent 65%)`,pointerEvents:'none' }} />
      <div className="container" style={{ position:'relative',zIndex:1 }}>
        <div style={{ maxWidth:640 }}>
          <span className="section-label" style={{ color: dark ? 'var(--accent)' : 'var(--accent)' }}>{label}</span>
          <h1 className="serif page-title" style={{ fontSize:'3.4rem',color: dark ? '#fff' : 'var(--text)',marginBottom:20,letterSpacing:'-0.02em' }}>{title}</h1>
          {subtitle && <p style={{ fontSize:'1.1rem',color: dark ? 'rgba(255,255,255,0.55)' : 'var(--text-muted)',lineHeight:1.7,maxWidth:520 }}>{subtitle}</p>}
        </div>
        {children}
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: SOBRE
════════════════════════════════════════════════════════════ */
const TEAM = [
  { name:'Jesus Rodrigues', role:'CEO & Fundador', bio:'Desenvolvedor full-stack especializado em fintech. Criou o SimulaBank para resolver a própria dor como correspondente bancário.', cor:'#3B82F6', ini:'DO' },
  { name:'Ana Martins', role:'CTO', bio:'Engenheira de software com 10 anos de experiência em sistemas financeiros e APIs de alta performance.', cor:'#8B5CF6', ini:'AM' },
  { name:'Carlos Mendes', role:'Head de Produto', bio:'Ex-gerente de crédito imobiliário no Itaú. Traz a visão do mercado para cada feature do produto.', cor:'#14B8A6', ini:'CM' },
  { name:'Luiza Souza', role:'Head de CS', bio:'Especialista em customer success com foco em escalar equipes de correspondentes bancários.', cor:'#F59E0B', ini:'LS' },
];
const VALUES = [
  { icon:'🎯', title:'Precisão acima de tudo', desc:'Nossos cálculos são calibrados com as tabelas oficiais de cada banco. Zero tolerância para imprecisão.' },
  { icon:'⚡', title:'Velocidade é produto', desc:'Cada segundo salvo na simulação é um segundo a mais com o cliente. Performance é feature.' },
  { icon:'🔓', title:'Transparência total', desc:'CET completo, todas as taxas visíveis, sem surpresas. O cliente merece informação clara.' },
  { icon:'🤝', title:'Parceiro do profissional', desc:'Existimos para que correspondentes bancários e imobiliárias fechem mais contratos com mais confiança.' },
];

export function SobrePage() {
  const { addReveal, revealStyle } = useReveal();
  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,padding:'12px 28px',borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, background:'var(--accent)', color:'var(--primary)' };

  return (
    <div className="sb-page">
      <Navbar />

      <PageHero label="Sobre nós" title={<>Construído por quem <em>viveu</em> o problema</>}
        subtitle="O SimulaBank nasceu da frustração de um correspondente bancário que perdia horas simulando banco por banco. Hoje ajudamos centenas de profissionais a fechar mais contratos." />

      {/* ── STORY ── */}
      <section style={{ padding:'100px 0' }}>
        <div className="container">
          <div className="g2" style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:80,alignItems:'center' }}>
            <div ref={addReveal} style={revealStyle}>
              <span className="section-label">Nossa história</span>
              <h2 className="serif" style={{ fontSize:'2.4rem',marginBottom:24 }}>De planilha para <em>plataforma</em></h2>
              <p style={{ color:'var(--text-muted)',lineHeight:1.8,marginBottom:20 }}>Em 2023, o fundador do SimulaBank passava 30 minutos por cliente apenas para comparar as condições de financiamento nos 6 bancos. A planilha era lenta, errava nas regras de seguro e não gerava PDF.</p>
              <p style={{ color:'var(--text-muted)',lineHeight:1.8,marginBottom:20 }}>O primeiro protótipo foi interno: uma ferramenta para uso próprio e da equipe. Em poucos meses, outros correspondentes queriam acesso. O SimulaBank virou produto.</p>
              <p style={{ color:'var(--text-muted)',lineHeight:1.8 }}>Hoje somos uma plataforma SaaS com cálculos validados, PDF white-label, integração com CRMs e uma API em desenvolvimento. E só estamos começando.</p>
            </div>
            <div ref={addReveal} style={{ ...revealStyle,transitionDelay:'0.1s' }}>
              <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:2,borderRadius:'var(--radius)',overflow:'hidden' }}>
                {[['2023','Protótipo interno'],['+200','Correspondentes ativos'],['6','Bancos integrados'],['2025','Plataforma SaaS lançada']].map(([v,l],i) => (
                  <div key={i} style={{ padding:'36px 28px',background:i%2===0?'var(--primary)':'var(--surface)',display:'flex',flexDirection:'column',justifyContent:'flex-end' }}>
                    <div style={{ fontSize:'2.2rem',fontWeight:700,color:i%2===0?'var(--accent)':'var(--primary)',marginBottom:8 }}>{v}</div>
                    <div style={{ fontSize:'0.82rem',color:i%2===0?'rgba(255,255,255,0.5)':'var(--text-muted)' }}>{l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── VALUES ── */}
      <section style={{ padding:'100px 0', background:'var(--surface)' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',maxWidth:560,margin:'0 auto 56px' }}>
            <span className="section-label">Nossos valores</span>
            <h2 className="serif" style={{ fontSize:'2.6rem' }}>O que nos guia</h2>
          </div>
          <div className="g4" style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:24 }}>
            {VALUES.map((v,i) => (
              <div key={v.title} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.1}s`,background:'#fff',borderRadius:'var(--radius)',padding:28,border:'1px solid var(--border)' }}>
                <div style={{ fontSize:'2rem',marginBottom:16 }}>{v.icon}</div>
                <div style={{ fontWeight:700,fontSize:'1rem',marginBottom:10 }}>{v.title}</div>
                <p style={{ fontSize:'0.85rem',color:'var(--text-muted)',lineHeight:1.6 }}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TEAM ── */}
      <section style={{ padding:'100px 0' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',maxWidth:560,margin:'0 auto 56px' }}>
            <span className="section-label">Time</span>
            <h2 className="serif" style={{ fontSize:'2.6rem',marginBottom:12 }}>As pessoas por trás do produto</h2>
          </div>
          <div className="g4" style={{ display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:24 }}>
            {TEAM.map((t,i) => (
              <div key={t.name} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.1}s`,background:'var(--surface)',borderRadius:'var(--radius)',padding:28,border:'1px solid var(--border)' }}>
                <div style={{ width:56,height:56,borderRadius:'50%',background:t.cor,display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:'1rem',color:'#fff',marginBottom:16 }}>{t.ini}</div>
                <div style={{ fontWeight:700,fontSize:'1rem',marginBottom:4 }}>{t.name}</div>
                <div style={{ fontSize:'0.78rem',color:'var(--accent)',fontWeight:600,marginBottom:12 }}>{t.role}</div>
                <p style={{ fontSize:'0.83rem',color:'var(--text-muted)',lineHeight:1.55 }}>{t.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{ padding:'80px 0', background:'var(--primary)' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <div ref={addReveal} style={revealStyle}>
            <h2 className="serif" style={{ fontSize:'2.6rem',color:'#fff',marginBottom:16 }}>Quer fazer parte da história?</h2>
            <p style={{ color:'rgba(255,255,255,0.5)',marginBottom:32,fontSize:'1rem' }}>Estamos contratando e buscando parceiros estratégicos.</p>
            <div style={{ display:'flex',gap:16,justifyContent:'center',flexWrap:'wrap' }}>
              <Link to="/carreiras" style={btnP}>Ver vagas abertas</Link>
              <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Falar com a gente')}`} target="_blank" rel="noopener noreferrer" style={{ ...btn, color:'#fff', border:'1.5px solid rgba(255,255,255,0.2)', background:'transparent' }}>Falar com a gente</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: BLOG
════════════════════════════════════════════════════════════ */
const POSTS = [
  { slug:'sac-ou-price',           category:'Crédito Imobiliário', title:'SAC ou Price: qual sistema de amortização é melhor para o seu cliente?', excerpt:'Entenda a diferença entre os dois sistemas e como apresentar a comparação de forma clara para fechar mais negócios.', date:'20 jan 2026', readTime:'8 min', featured:true, cor:'#3B82F6' },
  { slug:'simulacao-em-2-minutos', category:'Ferramentas',         title:'Como apresentar a simulação de financiamento em 2 minutos', excerpt:'Script e metodologia para transformar a simulação em uma apresentação convincente para o cliente.', date:'14 jan 2026', readTime:'5 min', cor:'#8B5CF6' },
  { slug:'taxas-bancos-2026',      category:'Mercado',             title:'Comparativo de taxas: os 6 maiores bancos em janeiro de 2026', excerpt:'Análise das taxas de juros e condições de financiamento imobiliário nos principais bancos brasileiros.', date:'7 jan 2026', readTime:'6 min', cor:'#14B8A6' },
  { slug:'o-que-e-cet',            category:'CET',                 title:'O que é o CET e por que ele importa mais que a taxa de juros', excerpt:'Custo Efetivo Total inclui seguros, tarifas e outros custos. Saiba como usá-lo como argumento de venda.', date:'30 dez 2025', readTime:'7 min', cor:'#F59E0B' },
  { slug:'erros-correspondente',   category:'Correspondente',      title:'5 erros que correspondentes bancários cometem ao simular financiamentos', excerpt:'Erros comuns que custam contratos e como evitá-los com a ferramenta certa.', date:'22 dez 2025', readTime:'5 min', cor:'#EF4444' },
  { slug:'mip-dfi',                category:'MIP/DFI',             title:'Seguro MIP e DFI no financiamento: o que são e como calculá-los', excerpt:'Guia completo sobre os seguros obrigatórios no financiamento imobiliário e o impacto na parcela.', date:'15 dez 2025', readTime:'9 min', cor:'#00D68F' },
];
const CATEGORIES = ['Todos','Crédito Imobiliário','Ferramentas','Mercado','CET','Correspondente','MIP/DFI'];

export function BlogPage() {
  const { addReveal, revealStyle } = useReveal();
  const [cat, setCat] = useState('Todos');
  const [posts, setPosts] = useState(POSTS); // start with hardcoded
  const [categories, setCategories] = useState(CATEGORIES);
  const [loading, setLoading] = useState(true);

  // Load from Firebase, merge with hardcoded
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const fbPosts = await getPublishedPosts();
        if (!cancelled && fbPosts.length > 0) {
          // Map Firebase posts to same shape as hardcoded
          const mapped = fbPosts.map(p => ({
            slug: p.slug,
            category: p.category,
            title: p.title,
            excerpt: p.subtitle || '',
            date: p.date,
            readTime: p.readTime,
            featured: false,
            cor: p.categoryCor || '#3B82F6',
            coverGradient: p.coverGradient,
            coverEmoji: p.coverEmoji,
          }));
          // Mark first as featured
          if (mapped.length > 0) mapped[0].featured = true;
          // Merge: Firebase posts first, then hardcoded that don't exist in Firebase
          const fbSlugs = new Set(mapped.map(p => p.slug));
          const combined = [...mapped, ...POSTS.filter(p => !fbSlugs.has(p.slug))];
          setPosts(combined);
          // Build categories from combined
          const allCats = ['Todos', ...new Set(combined.map(p => p.category))];
          setCategories(allCats);
        }
      } catch (e) {
        console.warn('Blog: Firebase unavailable, using hardcoded posts', e);
      }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, []);

  const filtered = cat === 'Todos' ? posts : posts.filter(p => p.category === cat);
  const [featured, ...rest] = filtered;

  return (
    <div className="sb-page">
      <Navbar />

      <PageHero label="Blog" title={<>Insights sobre <em>crédito imobiliário</em></>}
        subtitle="Artigos práticos para correspondentes bancários, assessorias de crédito e imobiliárias fecharem mais contratos." />

      {/* ── CATEGORIES ── */}
      <div style={{ borderBottom:'1px solid var(--border)',background:'#fff',position:'sticky',top:68,zIndex:100 }}>
        <div className="container">
          <div style={{ display:'flex',gap:0,overflowX:'auto',paddingBottom:1 }}>
            {categories.map(c => (
              <button key={c} onClick={() => setCat(c)} style={{ padding:'14px 20px',background:'none',border:'none',borderBottom:cat===c?'2px solid var(--accent)':'2px solid transparent',color:cat===c?'var(--primary)':'var(--text-muted)',fontWeight:cat===c?600:500,fontSize:'0.88rem',cursor:'pointer',whiteSpace:'nowrap',fontFamily:'inherit',transition:'all 0.2s' }}>{c}</button>
            ))}
          </div>
        </div>
      </div>

      <section style={{ padding:'80px 0' }}>
        <div className="container">
          {/* Featured */}
          {featured && (
            <div ref={addReveal} style={{ ...revealStyle,marginBottom:56 }}>
              <div className="blog-featured" className="g2">
                <div style={{ background:`linear-gradient(135deg, ${featured.cor}22, ${featured.cor}08)`,padding:'56px 48px',display:'flex',flexDirection:'column',justifyContent:'center',minHeight:320 }}>
                  <span style={{ fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em',color:featured.cor,marginBottom:12 }}>{featured.category} · Destaque</span>
                  <h2 className="serif" style={{ fontSize:'1.9rem',marginBottom:16,lineHeight:1.25 }}>{featured.title}</h2>
                  <p style={{ color:'var(--text-muted)',marginBottom:24,fontSize:'0.92rem',lineHeight:1.65 }}>{featured.excerpt}</p>
                  <div style={{ display:'flex',alignItems:'center',gap:16,fontSize:'0.8rem',color:'var(--text-muted)' }}>
                    <span>{featured.date}</span><span>·</span><span>{featured.readTime} de leitura</span>
                  </div>
                </div>
                <div style={{ background:'var(--surface)',display:'flex',alignItems:'center',justifyContent:'center',padding:48 }}>
                  <Link to={`/blog/${featured.slug}`} style={{ display:'inline-flex',alignItems:'center',gap:8,padding:'14px 28px',borderRadius:'var(--radius-sm)',background:'var(--accent)',color:'var(--primary)',fontWeight:700,textDecoration:'none',fontSize:'0.9rem' }}>Ler artigo →</Link>
                </div>
              </div>
            </div>
          )}

          {/* Grid */}
          <div className="blog-grid">
            {rest.map((p,i) => (
              <Link key={p.title} to={`/blog/${p.slug}`} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.08}s`,textDecoration:'none',color:'inherit',background:'#fff',borderRadius:'var(--radius)',border:'1px solid var(--border)',overflow:'hidden',display:'flex',flexDirection:'column',transition:'box-shadow 0.25s,transform 0.25s' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow='0 12px 40px rgba(0,0,0,0.1)'; e.currentTarget.style.transform='translateY(-3px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow='none'; e.currentTarget.style.transform='translateY(0)'; }}>
                <div style={{ height:160,background:`linear-gradient(135deg, ${p.cor}20, ${p.cor}08)`,display:'flex',alignItems:'center',justifyContent:'center',padding:32 }}>
                  <span style={{ fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em',color:p.cor,padding:'4px 12px',borderRadius:100,background:p.cor+'18',border:`1px solid ${p.cor}30` }}>{p.category}</span>
                </div>
                <div style={{ padding:'24px 24px 28px',flex:1,display:'flex',flexDirection:'column' }}>
                  <h3 style={{ fontSize:'1rem',fontWeight:700,lineHeight:1.35,marginBottom:12,flex:1 }}>{p.title}</h3>
                  <p style={{ fontSize:'0.84rem',color:'var(--text-muted)',lineHeight:1.6,marginBottom:20 }}>{p.excerpt}</p>
                  <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',fontSize:'0.78rem',color:'var(--text-muted)' }}>
                    <span>{p.date}</span><span>{p.readTime} leitura</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* Newsletter */}
          <div ref={addReveal} style={{ ...revealStyle,marginTop:72,background:'var(--surface)',borderRadius:'var(--radius)',padding:'48px 40px',border:'1px solid var(--border)',textAlign:'center' }}>
            <h3 className="serif" style={{ fontSize:'1.9rem',marginBottom:12 }}>Receba os próximos artigos</h3>
            <p style={{ color:'var(--text-muted)',marginBottom:28,fontSize:'0.95rem' }}>Toda sexta: dicas práticas e dados do mercado imobiliário para fechar mais contratos.</p>
            <form onSubmit={e => e.preventDefault()} className="blog-newsletter-form">
              <input type="email" placeholder="seu@email.com" style={{ flex:1,minWidth:200,padding:'13px 18px',borderRadius:'var(--radius-sm)',border:'1.5px solid var(--border)',fontSize:'0.95rem',fontFamily:'inherit',outline:'none',color:'var(--text)' }} />
              <button type="submit" style={{ padding:'13px 24px',borderRadius:'var(--radius-sm)',background:'var(--accent)',color:'var(--primary)',fontWeight:700,border:'none',cursor:'pointer',fontFamily:'inherit',fontSize:'0.9rem' }}>Inscrever-se</button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: CONTATO
════════════════════════════════════════════════════════════ */
const CONTACT_OPTIONS = [
  { icon:'💬', title:'WhatsApp', desc:'Resposta em minutos', action:'Abrir WhatsApp', href:`https://wa.me/5561991826667?text=${encodeURIComponent('Quero ajuda com o simulabank!')}`, cor:'#25D366' },
  { icon:'✉️', title:'Email', desc:'contato@simulabank.com.br', action:'Enviar email', href:'mailto:contato@simulabank.com.br', cor:'#3B82F6' },
  { icon:'📅', title:'Demo', desc:'Agende uma apresentação personalizada de 30 min', action:'Agendar demo', href:'#form', cor:'#8B5CF6' },
];

export function ContatoPage() {
  const { addReveal, revealStyle } = useReveal();
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ nome:'', email:'', empresa:'', assunto:'demo', msg:'' });

  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const inputS = { width:'100%',padding:'13px 16px',borderRadius:'var(--radius-sm)',border:'1.5px solid var(--border)',fontSize:'0.95rem',fontFamily:'inherit',outline:'none',color:'var(--text)',boxSizing:'border-box',transition:'border-color 0.2s' };

  return (
    <div className="sb-page">
      <Navbar />

      <PageHero label="Contato" title={<>Fale com a <em>gente</em></>}
        subtitle="Estamos aqui para ajudar. Escolha o canal mais conveniente ou preencha o formulário." />

      <section style={{ padding:'80px 0 120px' }}>
        <div className="container">
          {/* Contact options */}
          <div className="g3" style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:20,marginBottom:72 }}>
            {CONTACT_OPTIONS.map((c,i) => (
              <div key={c.title} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.1}s`,background:'var(--surface)',borderRadius:'var(--radius)',padding:'32px 28px',border:'1px solid var(--border)',textAlign:'center' }}>
                <div style={{ fontSize:'2.2rem',marginBottom:16 }}>{c.icon}</div>
                <div style={{ fontWeight:700,fontSize:'1.05rem',marginBottom:8 }}>{c.title}</div>
                <p style={{ fontSize:'0.85rem',color:'var(--text-muted)',marginBottom:20 }}>{c.desc}</p>
                <a href={c.href} style={{ ...btn,padding:'10px 22px',background:c.cor+'15',color:c.cor,border:`1px solid ${c.cor}30` }}>{c.action}</a>
              </div>
            ))}
          </div>

          {/* Form */}
          <div id="form" className="g2" style={{ display:'grid',gridTemplateColumns:'1fr 1.2fr',gap:72,alignItems:'start' }}>
            <div ref={addReveal} style={revealStyle}>
              <span className="section-label">Formulário</span>
              <h2 className="serif" style={{ fontSize:'2.2rem',marginBottom:16 }}>Envie sua mensagem</h2>
              <p style={{ color:'var(--text-muted)',lineHeight:1.7,marginBottom:32 }}>Preencha o formulário e retornamos em até 1 dia útil. Para demandas urgentes, prefira o WhatsApp.</p>
              <div style={{ display:'flex',flexDirection:'column',gap:20 }}>
                {[['📍 Endereço','Brasília, DF – Brasil'],['🕐 Horário','Seg–Sex: 8h às 18h'],['📞 Resposta típica','< em minutos via WhatsApp']].map(([l,v]) => (
                  <div key={l} style={{ display:'flex',gap:12,alignItems:'flex-start' }}>
                    <span style={{ fontSize:'0.88rem',color:'var(--text-muted)',lineHeight:1.5 }}><strong style={{ color:'var(--text)' }}>{l.split(' ').slice(1).join(' ')}</strong><br/>{v}</span>
                  </div>
                ))}
              </div>
            </div>
            <div ref={addReveal} style={{ ...revealStyle,transitionDelay:'0.1s' }}>
              {sent ? (
                <div style={{ textAlign:'center',padding:'60px 40px',background:'var(--surface)',borderRadius:'var(--radius)',border:'1px solid var(--border)' }}>
                  <div style={{ fontSize:'3rem',marginBottom:16 }}>✅</div>
                  <h3 style={{ fontSize:'1.4rem',fontWeight:700,marginBottom:12 }}>Mensagem enviada!</h3>
                  <p style={{ color:'var(--text-muted)' }}>Retornaremos em até 1 dia útil.</p>
                </div>
              ) : (
                <form onSubmit={e => { e.preventDefault(); setSent(true); }} style={{ display:'flex',flexDirection:'column',gap:16,background:'var(--surface)',padding:36,borderRadius:'var(--radius)',border:'1px solid var(--border)' }}>
                  <div className="g2" style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:16 }}>
                    <div>
                      <label style={{ fontSize:'0.82rem',fontWeight:600,color:'var(--text)',display:'block',marginBottom:6 }}>Nome *</label>
                      <input required value={form.nome} onChange={e => setForm({...form,nome:e.target.value})} placeholder="Seu nome" style={inputS} onFocus={e => e.target.style.borderColor='var(--accent)'} onBlur={e => e.target.style.borderColor='var(--border)'} />
                    </div>
                    <div>
                      <label style={{ fontSize:'0.82rem',fontWeight:600,color:'var(--text)',display:'block',marginBottom:6 }}>Email *</label>
                      <input required type="email" value={form.email} onChange={e => setForm({...form,email:e.target.value})} placeholder="seu@email.com" style={inputS} onFocus={e => e.target.style.borderColor='var(--accent)'} onBlur={e => e.target.style.borderColor='var(--border)'} />
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize:'0.82rem',fontWeight:600,color:'var(--text)',display:'block',marginBottom:6 }}>Empresa</label>
                    <input value={form.empresa} onChange={e => setForm({...form,empresa:e.target.value})} placeholder="Nome da empresa (opcional)" style={inputS} onFocus={e => e.target.style.borderColor='var(--accent)'} onBlur={e => e.target.style.borderColor='var(--border)'} />
                  </div>
                  <div>
                    <label style={{ fontSize:'0.82rem',fontWeight:600,color:'var(--text)',display:'block',marginBottom:6 }}>Assunto</label>
                    <select value={form.assunto} onChange={e => setForm({...form,assunto:e.target.value})} style={{ ...inputS,background:'#fff' }}>
                      <option value="demo">Agendar demonstração</option>
                      <option value="planos">Dúvida sobre planos</option>
                      <option value="api">Interesse na API</option>
                      <option value="parceria">Proposta de parceria</option>
                      <option value="outro">Outro</option>
                    </select>
                  </div>
                  <div>
                    <label style={{ fontSize:'0.82rem',fontWeight:600,color:'var(--text)',display:'block',marginBottom:6 }}>Mensagem *</label>
                    <textarea required rows={5} value={form.msg} onChange={e => setForm({...form,msg:e.target.value})} placeholder="Descreva como podemos ajudar..." style={{ ...inputS,resize:'vertical',lineHeight:1.6 }} onFocus={e => e.target.style.borderColor='var(--accent)'} onBlur={e => e.target.style.borderColor='var(--border)'} />
                  </div>
                  <button type="submit" style={{ ...btn,padding:'14px',background:'var(--accent)',color:'var(--primary)',fontSize:'0.95rem',width:'100%' }}>Enviar mensagem</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE: CARREIRAS
════════════════════════════════════════════════════════════ */
const JOBS = [
  { area:'Engenharia', title:'Engenheiro(a) Full-Stack Sênior', type:'CLT · Remoto', desc:'Trabalhe no core do produto: motor de cálculo, API REST e dashboard de simulações.', skills:['C# / .NET','React','SQL Server','Azure'] },
  { area:'Produto', title:'Product Designer', type:'PJ · Remoto', desc:'Evolua a experiência do SimulaBank para centenas de profissionais do crédito imobiliário.', skills:['Figma','Design System','User Research','Prototipagem'] },
  { area:'Engenharia', title:'Engenheiro(a) de Backend', type:'CLT · Remoto', desc:'Construa os fundamentos da nossa API pública e a infraestrutura de cálculo em escala.', skills:['C#','ASP.NET Core','REST API','Testes automatizados'] },
  { area:'Comercial', title:'Account Executive', type:'CLT · Híbrido (Brasília)', desc:'Ajude correspondentes e imobiliárias a descobrirem o SimulaBank e fechar contratos.', skills:['SaaS','Crédito imobiliário','Consultivo','CRM'] },
];
const PERKS = [
  { icon:'🏠', title:'100% remoto', desc:'Trabalhe de onde preferir, no Brasil.' },
  { icon:'📚', title:'Educação', desc:'Budget anual para cursos e conferências.' },
  { icon:'⏰', title:'Flexibilidade', desc:'Horário flexível com foco em resultado.' },
  { icon:'🚀', title:'Equity', desc:'Participação no crescimento da empresa.' },
  { icon:'💻', title:'Setup', desc:'MacBook Pro ou equivalente à sua escolha.' },
  { icon:'💚', title:'Saúde', desc:'Plano de saúde e odontológico.' },
];

export function CarreirasPage() {
  const { addReveal, revealStyle } = useReveal();
  const [filter, setFilter] = useState('Todos');
  const areas = ['Todos', ...new Set(JOBS.map(j => j.area))];
  const filtered = filter === 'Todos' ? JOBS : JOBS.filter(j => j.area === filter);

  const btn = { display:'inline-flex',alignItems:'center',justifyContent:'center',gap:8,borderRadius:'var(--radius-sm)',fontFamily:'inherit',fontSize:'0.9rem',fontWeight:600,textDecoration:'none',border:'none',cursor:'pointer' };
  const btnP = { ...btn, padding:'12px 28px', background:'var(--accent)', color:'var(--primary)' };

  return (
    <div className="sb-page">
      <Navbar />

      <PageHero dark label="Carreiras" title={<>Construa o futuro do <em>crédito imobiliário</em></>}
        subtitle="Somos um time pequeno resolvendo um problema grande. Se você quer impacto real e ownership, é aqui." />

      {/* ── PERKS ── */}
      <section style={{ padding:'100px 0' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,textAlign:'center',maxWidth:540,margin:'0 auto 56px' }}>
            <span className="section-label">Por que o SimulaBank</span>
            <h2 className="serif" style={{ fontSize:'2.6rem' }}>Benefícios e cultura</h2>
          </div>
          <div className="g3" style={{ display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:20 }}>
            {PERKS.map((p,i) => (
              <div key={p.title} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.08}s`,background:'var(--surface)',borderRadius:'var(--radius)',padding:'28px 24px',border:'1px solid var(--border)',display:'flex',gap:16,alignItems:'flex-start' }}>
                <div style={{ fontSize:'1.8rem',flexShrink:0 }}>{p.icon}</div>
                <div>
                  <div style={{ fontWeight:700,fontSize:'0.95rem',marginBottom:6 }}>{p.title}</div>
                  <p style={{ fontSize:'0.83rem',color:'var(--text-muted)',lineHeight:1.5 }}>{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── JOBS ── */}
      <section style={{ padding:'0 0 120px' }}>
        <div className="container">
          <div ref={addReveal} style={{ ...revealStyle,display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:36,flexWrap:'wrap',gap:16 }}>
            <h2 className="serif" style={{ fontSize:'2.2rem' }}>Vagas abertas</h2>
            <div style={{ display:'flex',gap:8 }}>
              {areas.map(a => <button key={a} onClick={() => setFilter(a)} style={{ padding:'8px 18px',borderRadius:100,border:filter===a?'none':'1px solid var(--border)',background:filter===a?'var(--accent)':'transparent',color:filter===a?'var(--primary)':'var(--text-muted)',fontWeight:600,fontSize:'0.82rem',cursor:'pointer',fontFamily:'inherit' }}>{a}</button>)}
            </div>
          </div>
          <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
            {filtered.map((j,i) => (
              <div key={j.title} ref={addReveal} style={{ ...revealStyle,transitionDelay:`${i*0.08}s`,background:'#fff',borderRadius:'var(--radius)',padding:'28px 32px',border:'1px solid var(--border)',display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:24,flexWrap:'wrap',transition:'box-shadow 0.25s' }}
                onMouseEnter={e => e.currentTarget.style.boxShadow='0 8px 32px rgba(0,0,0,0.08)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
                <div style={{ flex:1 }}>
                  <div style={{ display:'flex',alignItems:'center',gap:12,marginBottom:10,flexWrap:'wrap' }}>
                    <span style={{ fontSize:'0.72rem',fontWeight:700,textTransform:'uppercase',letterSpacing:'0.1em',padding:'3px 10px',borderRadius:100,background:'rgba(0,214,143,0.1)',color:'var(--accent)' }}>{j.area}</span>
                    <span style={{ fontSize:'0.78rem',color:'var(--text-muted)' }}>{j.type}</span>
                  </div>
                  <h3 style={{ fontSize:'1.1rem',fontWeight:700,marginBottom:8 }}>{j.title}</h3>
                  <p style={{ fontSize:'0.88rem',color:'var(--text-muted)',marginBottom:14,lineHeight:1.55 }}>{j.desc}</p>
                  <div style={{ display:'flex',gap:8,flexWrap:'wrap' }}>
                    {j.skills.map(s => <span key={s} style={{ fontSize:'0.75rem',padding:'4px 10px',borderRadius:'var(--radius-sm)',background:'var(--surface)',border:'1px solid var(--border)',color:'var(--text-muted)' }}>{s}</span>)}
                  </div>
                </div>
                <a href={`mailto:carreiras@simulabank.com.br?subject=Candidatura: ${j.title}`} style={{ ...btnP,flexShrink:0 }}>Candidatar-se</a>
              </div>
            ))}
          </div>

          {/* Candidatura espontânea */}
          <div ref={addReveal} style={{ ...revealStyle,marginTop:40,background:'var(--surface)',borderRadius:'var(--radius)',padding:'32px 36px',border:'1px solid var(--border)',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:20 }}>
            <div>
              <div style={{ fontWeight:700,fontSize:'1rem',marginBottom:4 }}>Não encontrou a vaga ideal?</div>
              <div style={{ fontSize:'0.88rem',color:'var(--text-muted)' }}>Mande sua candidatura espontânea. Guardamos seu perfil para futuras oportunidades.</div>
            </div>
            <a href="mailto:carreiras@simulabank.com.br?subject=Candidatura espontânea" style={{ ...btn,padding:'12px 24px',background:'var(--primary)',color:'#fff' }}>Candidatura espontânea</a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}